(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.SettingsIconSvg = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SettingsIcon = function SettingsIcon() {
    return _react2.default.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        xlink: "http://www.w3.org/1999/xlink",
        width: "56",
        height: "56",
        viewBox: "0 0 56 56"
      },
      _react2.default.createElement(
        "defs",
        null,
        _react2.default.createElement("circle", { id: "a", cx: "28", cy: "28", r: "28" })
      ),
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd" },
        _react2.default.createElement(
          "mask",
          { id: "b", fill: "#fff" },
          _react2.default.createElement("use", { href: "#a" })
        ),
        _react2.default.createElement("use", { fill: "#DFE1E7", href: "#a" }),
        _react2.default.createElement(
          "g",
          { mask: "url(#b)" },
          _react2.default.createElement("path", {
            fill: "#757D99",
            d: "M26.604 33.213a7.92 7.92 0 0 1 2.533-1.064v2.457h2.655V32a7.916 7.916 0 0 1 3.418 1.213l-1.59 1.896 2.033 1.706 1.522-1.813a7.928 7.928 0 0 1 1.586 3.586h-2.987v2.655h2.987a7.917 7.917 0 0 1-1.178 3.018l-1.045-1.245-2.033 1.707 1.261 1.504a7.925 7.925 0 0 1-3.974 1.605v-2.606h-2.655v2.457a7.932 7.932 0 0 1-3.09-1.456l1.262-1.504-2.033-1.707-1.045 1.245a7.917 7.917 0 0 1-1.178-3.018h2.102v-2.655h-2.102a7.928 7.928 0 0 1 1.586-3.586l1.522 1.813 2.033-1.706-1.59-1.896zm4.303 9.358a2.655 2.655 0 1 0 0-5.31 2.655 2.655 0 0 0 0 5.31z"
          }),
          _react2.default.createElement("path", {
            fill: "#FFF",
            d: "M33.276 13.443a9.42 9.42 0 0 1 3.014-1.266V15.1h3.158V12a9.416 9.416 0 0 1 4.066 1.443l-1.892 2.255 2.42 2.03 1.81-2.157a9.43 9.43 0 0 1 1.886 4.266h-3.553v3.158h3.553a9.417 9.417 0 0 1-1.402 3.59l-1.242-1.481-2.42 2.03 1.501 1.788a9.426 9.426 0 0 1-4.727 1.91v-3.1H36.29v2.923a9.435 9.435 0 0 1-3.675-1.733l1.501-1.788-2.42-2.03-1.241 1.48a9.417 9.417 0 0 1-1.402-3.59h2.5v-3.157h-2.5a9.43 9.43 0 0 1 1.886-4.266l1.81 2.157 2.42-2.03-1.893-2.255zm5.12 11.13a3.158 3.158 0 1 0 0-6.315 3.158 3.158 0 0 0 0 6.316z"
          }),
          _react2.default.createElement("path", {
            fill: "#47506B",
            d: "M13.673 14.353A13.801 13.801 0 0 1 19.372 12v4.433h4.625V12a13.792 13.792 0 0 1 5.165 1.994l-2.852 3.4 3.543 2.973 2.737-3.263a13.813 13.813 0 0 1 2.778 6.268h-4.433v4.625h4.433a13.803 13.803 0 0 1-2.415 5.786l-1.944-2.317-3.543 2.973 2.187 2.606a13.8 13.8 0 0 1-5.656 2.323v-4.433h-4.625v4.433a13.804 13.804 0 0 1-5.817-2.437l2.09-2.492-3.542-2.973-1.805 2.15A13.8 13.8 0 0 1 8 27.997h4.433v-4.624H8a13.802 13.802 0 0 1 2.384-5.743l2.297 2.738 3.543-2.973-2.551-3.04zm8.011 15.957a4.625 4.625 0 1 0 0-9.251 4.625 4.625 0 0 0 0 9.25z"
          })
        )
      )
    );
  };

  exports.default = SettingsIcon;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Tabber/icons/SettingsIcon.svg.js
// module id = 1242
// module chunks = 0